import BlockObserver from "./BlockObserver";
import Splide from "@splidejs/splide";

export default class WhatWeDo {
    init(block) {
        this.menuButtons        = block.querySelectorAll('[data-menu]');
        this.blockTiles         = block.querySelectorAll('[data-tile]');
        let mobileSplideHeight = window.innerHeight - 72;

        let main = new Splide(block.querySelector('.what-we-do__list'), {
            type                : 'fade',
            rewind              : false,
            pagination          : false,
            arrows              : false,
            perPage		        : 1,
            wheel               : true,
            waitForTransition   : true,
            wheelSleep          : 1000,
            wheelMinThreshold   : 10,
            breakpoints: {
                1023: {
                    direction : 'ttb',
                    height : mobileSplideHeight
                }
            }
        });

        main.mount();

        // Island navigation
        this.menuButtons && this.menuButtons.forEach((menuButton) => {
            menuButton.addEventListener('click', (event) => {
                this.menuButtons.forEach((button) => {
                    button.classList.remove('selected');
                });
                menuButton.classList.add('selected');
                main.go(Number(menuButton.dataset.menu));
            });
        });

        // After slide change, update island navigation
        main.on('moved', function (index) {
            block.querySelectorAll('[data-menu]').forEach((button) => {
                button.classList.remove('selected');
                if(Number(button.getAttribute("data-menu")) === index) {
                    button.classList.add('selected');
                }
            });
        });
    }
}